export default __webpack_public_path__ + "static/Calibre-LightItalic-fd5ed43896ae954a0c3f27416fe4f073.woff2";